import React, { useMemo, useCallback } from 'react';

import {
  Row,
  Col,
  Card,
  CardHeader,
  Button,
  CardBody,
  Alert,
  Table
} from 'reactstrap';

import { drawTooltipHelp } from "../../../../../../helper/form";

import WorkflowHttpRequestInputStageFormFileItemAttributes from './attributes';

const WorkflowHttpRequestInputStageFormFileItemList = props => {

  const {
    currentNode,
    callbacks: {
      onSetCurrentNode,
      activeInputStageFileItems
    },
    configuration: {
      stageForm = 'input_stage_form'
    } = {}
  } = props;

  const fileItems = useMemo(() => {
    return currentNode?.data[stageForm]['file_items'] || [];
  }, [currentNode?.data[stageForm]['file_items']])

  const generateCustomId = useMemo(() => {
    return `${ Math.random().toString(36).slice(2) }-${ moment().toDate().getTime() }-${ fileItems.length }`;
  }, [fileItems.length])


  // ---------- START ADD FILE ITEM ----------
  const onAddFileItem = () => {
    const fileItemAttributes = {
      id: '',
      name: '',
      is_required: false,
      _destroy: false,
      custom_id: generateCustomId
    }

    if(_.isFunction(onSetCurrentNode)){
      onSetCurrentNode(prevState => {
        prevState.data[stageForm]['file_items'] = [
          ... prevState.data[stageForm]['file_items'],
          fileItemAttributes
        ]

        return { ... prevState }
      })
    }
  }
  // ---------- END ADD FILE ITEM ----------
  // ----------------------------------------
  // ---------- START FILE ITEMS ATTRIBUTES ----------
  const onChangeFileItem = useCallback((fileItem, customId) => {
    onSetCurrentNode(prevState => {

      let bodyRequestContent = [... prevState.data.body_request_content ]

      if(fileItem._destroy){
        _.map(bodyRequestContent, bodyRequestContentItem => {
          if(bodyRequestContentItem.value.includes(customId)){
            bodyRequestContentItem.value = ''
          }
          return bodyRequestContentItem
        })
      }

      return {
        ...prevState,
        data: {
          ...prevState.data,
          body_request_content: bodyRequestContent,
          [stageForm]: {
            ...prevState.data[stageForm],
            file_items: _.map(prevState.data[stageForm].file_items, item => {
              if(item.custom_id == customId){
                return fileItem
              } else {
                return item
              }
            })
          }
        }
      }
    })
  }, [fileItems])

  const hasFileItemsActive = useMemo(() => {
    return activeInputStageFileItems.length > 0
  }, [activeInputStageFileItems])

  const fileItemsAttributes = () => {
    if(hasFileItemsActive){
      return(
        <Row>
          <Col md={ 12 }>
            <Table>
              <thead>
                <tr>
                  <th className='text-center'>
                    { I18n.t('activerecord.attributes.workflow/stage_file_item.name') }
                    { drawTooltipHelp(I18n.t('activerecord.help.workflow/stage_file_item.name')) }
                  </th>
                  <th className='text-center'>
                    { I18n.t('actions.upload_file') }
                  </th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                { _.map(activeInputStageFileItems, (fileItem) => {
                  return(
                    <WorkflowHttpRequestInputStageFormFileItemAttributes
                      key={ `WorkflowHttpRequestStageInputFileItemAttributes-${ fileItem.custom_id }` }
                      fileItem={ fileItem }
                      callbacks={{
                        onChangeFileItem: onChangeFileItem
                      }}
                    />
                  )
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
      )
    } else {
      return(
        <Alert color="primary" className="text-center" role="alert" fade={ false }>
          <i className="fas fa-info-circle mr-2" aria-hidden="true" title="Información"/>
          Aún no has agregado documentos
        </Alert>
      )
    }
  }
  // ---------- END FILE ITEMS ATTRIBUTES ----------


  return (
    <Row>
      <Col md={ 12 }>
        <Card>
          <CardHeader>
            <div className="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap">
              <div className="font-weight-bold">
                <i className="fas fa-copy mr-2"></i>
                { I18n.t('activerecord.models.workflow/stage_file_item.other') }
              </div>
              <div className="text-end">
                <Button
                  outline
                  color='success'
                  size="sm"
                  onClick={ onAddFileItem }
                >
                  { I18n.t('actions.add') }
                </Button>
              </div>
            </div>
          </CardHeader>

          <CardBody>
            { fileItemsAttributes()}
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default WorkflowHttpRequestInputStageFormFileItemList;
